var localOrPgRegexp = /(localhost|playground|cheggnet|local\.)/;
export default function isProduction() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof window !== 'undefined' ? window.location.hostname : '';
  if (!hostname) {
    return false;
  }
  return !localOrPgRegexp.test(hostname);
}